<template>
  <div class="flex items-center justify-center gap-16 p-8" style="align-items: flex-end;">
    <!-- iPhone 外框（严格 285px × 507px） -->
    <div class="iphone-frame short">
      <div class="iphone-screen flex flex-col" :style="{'background-image': 'url(' + background_src + ')'}">
        <!-- 状态栏 -->
        <div class="status-bar flex items-center justify-between px-6 pt-3 text-sm font-semibold text-black">
          <div>9:41</div>
          <div class="flex items-center gap-3">
            <!-- 信号强度 -->
            <div class="flex gap-[2px]" style="align-items: flex-end;">
              <div class="w-[3px] h-[4px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[7px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[10px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[13px] bg-black rounded-sm"></div>
            </div>
            <!-- WiFi -->
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z" fill="#111"/>
              <path d="M3.5 8.5C3.5 8.5 6 5 9.5 5C13 5 15.5 8.5 15.5 8.5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M1 5C1 5 5 1 9.5 1C14 1 18 5 18 5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            <!-- 电池 -->
            <div class="flex items-center gap-px">
              <div class="border border-black rounded-[3px] w-[22px] h-[10px] relative">
                <div class="absolute top-[1px] left-[1px] h-[6px] w-[16px] bg-black rounded-[1px]"></div>
              </div>
              <div class="w-[2px] h-[6px] bg-black rounded-r"></div>
            </div>
          </div>
        </div>
        
        <!-- 主屏幕空白区域 -->
        <div class="flex-1">
          <div class="iconbackground" v-if="!background_src && !icon_src">LOGO</div>
          <div class="iconBox" v-if="icon_src" :style="{'background-image': 'url(' + icon_src + ')'}"></div>
        </div>
        
      </div>
    </div>
    <!-- iPhone 外框（严格 285px × 617px） -->
    <div class="iphone-frame">
      <div class="iphone-screen flex flex-col" :style="{'background-image': 'url(' + background_high_src + ')'}">
        
        <!-- 状态栏 -->
        <div class="status-bar flex items-center justify-between px-6 pt-3 text-sm font-semibold text-black">
          <div>9:41</div>
          <div class="flex items-center gap-3">
            <!-- 信号强度 -->
            <div class="flex gap-[2px]" style="align-items: flex-end;">
              <div class="w-[3px] h-[4px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[7px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[10px] bg-black rounded-sm"></div>
              <div class="w-[3px] h-[13px] bg-black rounded-sm"></div>
            </div>
            <!-- WiFi -->
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5 11.5C10.3284 11.5 11 10.8284 11 10C11 9.17157 10.3284 8.5 9.5 8.5C8.67157 8.5 8 9.17157 8 10C8 10.8284 8.67157 11.5 9.5 11.5Z" fill="#111"/>
              <path d="M3.5 8.5C3.5 8.5 6 5 9.5 5C13 5 15.5 8.5 15.5 8.5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M1 5C1 5 5 1 9.5 1C14 1 18 5 18 5" stroke="#111" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            <!-- 电池 -->
            <div class="flex items-center gap-px">
              <div class="border border-black rounded-[3px] w-[22px] h-[10px] relative">
                <div class="absolute top-[1px] left-[1px] h-[6px] w-[16px] bg-black rounded-[1px]"></div>
              </div>
              <div class="w-[2px] h-[6px] bg-black rounded-r"></div>
            </div>
          </div>
        </div>
        
        <!-- 主屏幕空白区域 -->
        <div class="flex-1">
          <div class="iconbackground high" v-if="!background_high_src && !icon_src">LOGO</div>
          <div class="iconBox high" v-if="icon_src" :style="{'background-image': 'url(' + icon_src + ')'}"></div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'phone-three',
    props:['icon_src', 'background_src', 'background_high_src'],
    data(){
      return {

      }
    },
  }
</script>

<style scoped>
.iphone-frame {
  width: 285px;
  height: 617px;
  background: #ffffff;
  border-radius: 30px;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
  position: relative;
  overflow: hidden;
  border: 2px solid #11111150;
}
.iphone-frame.short{
  height: 507px;
}

.iphone-screen {
  width: 100%;
  height: 100%;
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.status-bar {
  height: 44px;
}

.tab-bar {
  box-shadow: 0 -1px 0 #c6c6c8;
}
.iconbackground{
  background: rgb(156,156,156);
  margin: 50px auto 0;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-weight: 600;
  font-size: 30px;
  color: rgb(255,255,255);
  user-select: none;
}
.iconBox{
  margin: 50px auto 0;
  width: 80px;
  height: 80px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.iconbackground.high{
  margin-top: 70px;
}
.iconBox.high{
  margin-top: 70px;
}
</style>